import { IconProps } from "../../models/Icon";

export function ArrowIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {
  return (
    <svg width={size} height={size} opacity={opacity} viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 7H17M17 7L11.5217 1.5M17 7L11.5217 12.5" stroke="#434343" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  )
}